import { AuthService } from 'src/app/services/auth.service';
import { SharedService } from './../../../services/shared.service';
import { Address } from './../../../models';
import { UserService } from './../../../services/user.service';
import { Component, OnInit } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { Title } from '@angular/platform-browser';
import { first } from 'rxjs/internal/operators/first';
import * as jquery from 'jquery';

@Component({
  selector: 'delivery-address',
  templateUrl: './delivery-address.component.html',
  styleUrls: ['./delivery-address.component.scss']
})
export class DeliveryAddressComponent implements OnInit {

  addressForm: FormGroup;
  loading = false;
  submitted = false;
  error = false;
  errorMsg: string;
  countries: any[] = [];
  countryError = false;
  countryId: any;
  line2: string;
  disabledLink = true;
  disabledButton = false;
  showCountryLabel = false;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private pageTitleService: Title,
    private userService: UserService,
    private shareService: SharedService,
    private authService: AuthService
  ) { }

  ngOnInit(): void {
    this.setPageTitle();
    this.setFormControls();
    this.setSelect2Box();
    this.getCountries();
    this.countrySelectOnChange();
    this.getDeliveryDetails();
  }

  getDeliveryDetails() {
    if (window.history.state && window.history.state.hasOwnProperty('from')) {
      if (window.history.state.from == 'payment-method') {
        this.disabledButton = true;
        setTimeout(() => {
          this.userService.getDeliveryAddress()
            .pipe(first())
            .subscribe(
              deliveryData => {
                const address = deliveryData.data.delivery;
                this.f.line1.setValue(address.line1);
                this.line2 = address.line2;
                this.f.suburb.setValue(address.suburb);
                this.f.city.setValue(address.city);
                this.f.postcode.setValue(address.postcode);
                jquery('.country-select').val(address.country_id).trigger('change');
                jquery('.select2-container').addClass('active');
                this.countryId = address.country_id;

                this.disabledButton = false;
              }
            );
        }, 1000);
      }
    }
  }

  countrySelectOnChange() {
    jquery('.country-select').on('select2:select', (e) => {
      const data = e.params.data;
      this.countryId = data.id;
      this.showCountryLabel = true;
      jquery('.select2-container').removeClass('error');
      jquery('.select2-selection__rendered').removeClass('error');
      jquery('.select2-container').addClass('active');
    });
  }

  setSelect2Box() {
    jquery('.country-select').select2({theme: 'matarial', placeholder: 'Country*'});
  }

  setPageTitle() {
    this.pageTitleService.setTitle(this.route.snapshot.data.title || 'Delivery Address');
  }

  getCountries() {
    this.shareService.getCountries()
      .pipe(first())
      .subscribe(
        countryData => {
          const tempCountries = countryData.data.countries;
          Object.keys(tempCountries).forEach(key => {
            this.countries.push({
              id: key,
              value: tempCountries[key]
            });
          });
          this.countries.sort(this.sortByValues);
        }
      );
  }

  private sortByValues(a, b) {
    const bandA = a.value.toUpperCase();
    const bandB = b.value.toUpperCase();

    let comparison = 0;
    if (bandA > bandB) {
      comparison = 1;
    } else if (bandA < bandB) {
      comparison = -1;
    }
    return comparison;
  }

  // Convenience getter for easy access to form fields
  get f() { return this.addressForm.controls; }

  setFormControls() {
    this.addressForm = new FormGroup({
      line1: new FormControl('', [
        Validators.required
      ]),
      line2: new FormControl('', []),
      suburb: new FormControl('', [
        Validators.required
      ]),
      city: new FormControl('', [
        Validators.required
      ]),
      postcode: new FormControl('', [
        Validators.required
      ])
    });
  }

  onSubmit() {
    this.submitted = true;

    if (this.countryId == undefined) {
      this.countryError = true;
      jquery('.select2-container').addClass('error');
      jquery('.select2-selection__rendered').addClass('error');
      return;
    }

    // Stop here if there's form errors
    if (this.addressForm.invalid && this.countryId == undefined) {
        return;
    }

    this.loading = true;
    const postData: Address =  {
      line1: this.f.line1.value,
      line2: (this.line2) ?? '',
      suburb: this.f.suburb.value,
      city: this.f.city.value,
      postcode: this.f.postcode.value,
      country: this.countryId,
    };

    this.userService.setDeliveryAddress(postData)
      .pipe(first())
      .subscribe(
        data => {
          if (!data.success) {
            this.error = true;
            this.loading = false;
            this.errorMsg = data.error.msg;

            // Hides the error message after 5 seconds
            setTimeout(function() {
              this.error = false;
            }.bind(this), 5000);

            // Scroll the sidenav to top
            const container = document.getElementById('sign-up-sidenav');
            container.scrollTop = 0;

            return;
          }
          this.loading = false;
          this.router.navigateByUrl('/payment-method', {state: {email: this.authService.currentUserValue.email, from: 'delivery-address'}});
        },
        error => {
          this.error = true;
          this.loading = false;
        });
  }

}
